// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"7b8f3302","149":"ca9a56ee","189":"dc05ef26","397":"153af629","424":"a902330b","490":"0b409040","518":"7e232b85","667":"d2397b87","781":"10b9477e"}[chunkId] + ".chunk.js";
};